// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_FeY","colMin":"styles_colMin__rsi88"};